import {
  AddressInput,
  EmailField,
  InputText,
  PhoneNumberField,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { classNames } from "../../helper";
import { PiCheckBold } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { useEffect } from "react";

function CustomerInfo() {
  const { control, register, getValues, watch, reset, setValue } =
    useFormContext();
  const allowSNSChecked = watch("customerInfo.allowSMS");
  const { t } = useTranslation();
  const claim = useSelector((state: RootState) => state.claim);

  useEffect(() => {
    const values = getValues();
    values.customerInfo = {
      first_name: claim?.first_name || "",
      last_name: claim?.last_name || "",
      email: claim?.email || "",
      number: claim?.phone_number || "",
      address1: claim?.address_1 || "",
      address2: claim?.address_2 || "",
      city: claim?.city || "",
      state: claim?.state || "",
      zip: claim?.zip || "",
      allowSMS: claim?.allowSMS || true,
    };
    reset(values);
    return () => {};
  }, [claim, getValues, reset]);

  return (
    <div className="space-y-3">
      <InputText
        control={control}
        name="customerInfo.first_name"
        required
        label="First Name"
      />
      <InputText
        control={control}
        name="customerInfo.last_name"
        required
        label="Last Name"
      />
      <EmailField
        control={control}
        name="customerInfo.email"
        required
        label="Email"
      />
      <PhoneNumberField
        control={control}
        name="customerInfo.number"
        required
        label="Mobile Number"
      />
      <label className="flex flex-row  select-none items-center">
        <input
          type="checkbox"
          className="hidden"
          {...register("customerInfo.allowSMS")}
        />
        <div
          className={classNames(
            allowSNSChecked ? "border-[#2D6CCA] " : " border-[#DFDFDF]",
            "h-4 m-1 w-4 shrink-0 cursor-pointer bg-white rounded border flex items-center justify-center transition-all"
          )}
          aria-hidden="true"
        >
          {allowSNSChecked && <PiCheckBold className="size-3 text-[#2D6CCA]" />}
        </div>
        <span className="text-sm tracking-tight ms-0.5">
          {t(
            "I would like to receive claim updates via SMS messages. Opt-out anytime."
          )}
        </span>
      </label>
      <AddressInput
        control={control}
        name="customerInfo.address1"
        onAddressSelect={(address) => {
          setValue("customerInfo.city", address.city);
          setValue("customerInfo.state", address.state);
          setValue("customerInfo.zip", address.zipCode);
        }}
        required
        label="Address 1"
      />
      <InputText
        label={"Address 2"}
        control={control}
        name={"customerInfo.address2"}
      />
      <InputText
        label={"City"}
        control={control}
        name={"customerInfo.city"}
        required
      />
      <InputText
        label={"State"}
        control={control}
        name={"customerInfo.state"}
        required
      />
      <InputText
        label={"Zip"}
        control={control}
        name={"customerInfo.zip"}
        required
      />
    </div>
  );
}

export default CustomerInfo;
